import { stringify } from "querystring";
import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../MyContext";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../Api";
import FooterText from "../Footer/Footer";
import { Status, useSession } from "../session/Context";
import { toast } from 'react-toastify'
import { getCredentialSubject } from "../schema/Utils";
import Input from "../schema/Input";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";



export default function Issue() {
  const [params] = useSearchParams();

  const [display, setDisplay] = useState<any>({});
  const [order, setOrder] = useState<string[]>([]);
  const [data, setData] = useState<any>({});
  const [issueName, setIssueName] = useState<any>("");
  const { status } = useSession();
  const [msg, setMsg] = useState("");

  const { onPage, setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);

  const brand = params.get('brand');
  const [issuance, setIssuance ] = useState("");
  const [scope, setScopes] = useState<any>();
  const [loading, setLoading] = useState(true);

  // Get scope
  
  useEffect(() => {
      let x = params.get('issuance')
      if(x !== null){
          setIssuance(x)
      }      
  }, [])

  const setPartialData = (name: string, val: any): void => {
    //console.log("setting data", name, val);
    setData({ ...data, [name]: val });
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    const brand = params.get("brand");
    const issuance_id = params.get("issuance");
    let url = "/api/v1/brand";
    if (brand) {
      url += "/" + brand;
    } else {
      url += "/root";
    }
    const id = params.get("id");
    url += "/" + issuance_id + "?id=" + id;

    API(url, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.redirect_uri) {
          window.location.href =
            response.redirect_uri +
            "?code=" +
            response.code +
            "&state=" +
            response.state;
        } else {
          if (response.email) {
            toast.success("Email sent successfully", { theme: "colored" });
            setMsg(
              "Request was successfuly sent. Check your email(" +
                response.email +
                ") for further information."
            );
          }
        }
      })
      .catch((e) => {
        toast.error("Error " + e, { theme: "colored" });
        console.error(e);
      });
  };

  useEffect(() => {
    const brand = params.get("brand");
    const issuance_id = params.get("issuance");
    let url = "/api/v1";
    
    /*
    let tempdata = data;
        {order.map((id) => {
            if(display[id].type === 'array'){
               
                let tempValue = data[id].toString();

                if(tempValue !== null && tempValue !== undefined){
                    const myArray = tempValue.split(",");

                    tempdata[id]= myArray
                }
            }
        })}
        
        API(url, {
            method: "POST",
            body: JSON.stringify(tempdata),
        }).then((response) => {
            if(response.redirect_uri) {
                window.location.href = response.redirect_uri + "?code=" + response.code + "&state=" + response.state;
            } else {
                if(response.email) {
                    toast.success("Email sent successfully", {theme:"colored"});
                    setMsg("Request was successfuly sent. Check your email(" + response.email + ") for further information.");
                }
            }
        }).catch((e) => {
            toast.error("Error " +  e, {theme:"colored"});
            console.error(e);
        })
     */

    if (brand) {
      url += "/brand/" + brand;
    } else {
      url += "/brand/root";
    }
    url += "/" + issuance_id + "?type=config";
    API(url)
      .then((response) => {
        setIssueName(response.metadata.display.name);
        setDisplay(response.metadata.credentialSubject);
        if (response.metadata.order && response.metadata.order.length > 0) {
          setOrder(response.metadata.order);
        } else {
          setOrder(Object.keys(response.metadata.credentialSubject));
        }

        //Scope
        if( response ){
            setScopes(response)
        }
        setLoading(false);
    })
    .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <main>
        <div className="mobile-pro">
          <div className="login">
            <img src="img/issue-icon-default.svg" />
            <h2>Issue Credential</h2>
          </div>
        </div>
        {status !== Status.LOADED && status !== Status.NOTHING && (
          <div className="col-visual col-visual-protect w-50">
            <h2>{issueName}</h2>
            <FooterText />
          </div>
        )}

        <div className="col-content">
          <div className="notifications-container">
            <div className="details-pro-section">

            {msg === "" && !loading  ? (<>

                <h2>Issuance credential form</h2>
                <form className="form" onSubmit={onSubmit}>

                    {(scope && scope.id !== "authorized.verifier.credential.v1") || issuance === "" ? (<>
                        
                        {issuance !== "" && (
                            <Input
                            content={getCredentialSubject(
                                scope.schema.content
                            )}
                            required
                            onChange={(val:any) => {       
                              console.log("changed", val);               
                                setData(val);
                            }}
                            ></Input>
                        )}
                        
                    </>) : (<>
                        
                        <label>Authorize Recipient's Verification Permissions</label>
                        {/* <Select
                            required
                            className="template-field"
                            value={selectedAuthType}
                            onChange={(event: SelectChangeEvent) => {
                            setSelectedAuthType(event.target.value);
                            }}
                            displayEmpty
                            renderValue={(value:any) => {
                            if (value == "") {
                                return (
                                <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                                    Select Credential Template
                                </em>
                                );
                            } else {
                                return (
                                <em style={{ fontSize: "15px" }}>
                                    {scope[selectedAuthType].schema.content.title}
                                </em>
                                );
                            }
                            }}
                        >
                            {scope[issuance]
                            .filter(
                                (item:any) => item.id !== "authorized.verifier.credential.v1"
                            )
                            .map((item:any, index:any) => {
                                return (
                                <MenuItem
                                    selected={index === 0}
                                    key={item.value}
                                    value={item.value}
                                >
                                    {item.label}
                                </MenuItem>
                                );
                            })} 
                        </Select> */}
                        
                    </>)}
        
                    <input
                      className="form-submit-btn btn btn-primary"
                      key="submit"
                      type="submit"
                      value="Submit"
                    ></input>
                  </form>
                </>
              ) : (
                <div>{msg}</div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
